import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Mui Libraries
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Notification from '../../../pages/General/Notification'

// Components
import Nonintegrated from './NonintegratedPage'
import Integrated from './IntegratedPage'

const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(3),
    textAlign: 'center',
    color: '#1E293B',
    backgroundColor: '#FFFFFF',
    border: "1px solid #E2E8F0",
    borderRadius: '16px',
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)",
    height: '100%',
    boxSizing: 'border-box',
    overflow: 'hidden'
}));

const IntegrationPage = ({ }) => {
    const integrations = useSelector(state => state.integrations);
    const channelconfig = useSelector(state => state.email && state.email.channelconfig);
   
    return (
        <Box sx={{ width: '100%', boxSizing: 'border-box' }}>
            {/* Realtime Alert Channel Intercept Overlay System Panel */}
            {(channelconfig && channelconfig.notification && channelconfig.notification.showMessage) && (
                <Notification
                    is_open={channelconfig.notification.showMessage}
                    messageType={channelconfig.notification.messageType}
                    messages={channelconfig.notification.messageContent}
                    handleClose={""}
                />
            )}
            
            <Box className="scmaincard" sx={{ width: '100%' }}>
                <Box className="integration--stores" sx={{ width: '100%' }}>
                    <Grid container spacing={3}>
                        
                        {/* Column A: Marketplace Channels Showcase & Discover Panel */}
                        <Grid item xs={12} lg={6}>
                            <Item>
                                <Box className="integration--stores--main" sx={{ width: '100%', mb: 3 }}>
                                    <Box className="integration--stores--head" sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1 }}>
                                        <Box className="integration--stores--title" sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Typography 
                                                variant="h5" 
                                                component="h2" 
                                                sx={{ 
                                                    fontWeight: 800, 
                                                    color: '#0F172A', 
                                                    letterSpacing: '-0.5px',
                                                    textAlign: 'left',
                                                    fontSize: '1.25rem',
                                                    m: 0
                                                }}
                                            >
                                                Notifications
                                            </Typography>
                                        </Box>
                                        
                                        {/* Asynchronous Asset Dispatch Network Progression Bar */}
                                        {integrations && integrations.platform.loading === true && (
                                            <Box sx={{ width: '100%', mt: 0.5 }}>
                                                <LinearProgress 
                                                    sx={{ 
                                                        height: '3px', 
                                                        borderRadius: '2px', 
                                                        backgroundColor: '#E2E8F0', 
                                                        '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } 
                                                    }} 
                                                />
                                            </Box>
                                        )}
                                    </Box>
                                </Box>
                                
                                <Nonintegrated />
                            </Item>
                        </Grid>
                        
                        {/* Column B: Configured Active Connected Subsystem Portals Panel */}
                        <Grid item xs={12} lg={6}>
                            <Item>
                                <Integrated />
                            </Item>
                        </Grid>
                        
                    </Grid>
                </Box>
            </Box>
        </Box>
    );
};

export default IntegrationPage;